import { IconButton, Stack, Tooltip } from "@mui/material";
import { FaGear, FaMagnifyingGlass, FaPen, FaTrash } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ListingPage from "../../components/DynamicListingPage";
import { deleteMetal, getMetals } from "../../helpers/http_metals_requests";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { usePermissions } from "../../providers/PermissionsProvider";
import { confirmAndExecuteFn } from "../../utils/functions";

const kindLabel = { 1: "Cotação ouro 18K", 2: "Cotação ouro 10K", 3: "Cotação prata" };

export default function Metals() {
    const { verifyPermission } = usePermissions();
    const queryClient = useQueryClient();
    const componentName = "logs";

    const { data, isFetching, refetch } = useQuery({
        queryKey: ["getMetals"],
        queryFn: getMetals,
        staleTime: 1000 * 5,
    });

    const dataList = Array.isArray(data?.data?.data) ? data.data.data : [];

    const deleteMutation = useMutation({
        mutationFn: (id) => deleteMetal(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getMetals"] });
            setTimeout(() => refetch(), 1000);
        },
    });

    const handleDelete = (id) => {
        confirmAndExecuteFn("Tem certeza que deseja desativar este metal?", () => {
            deleteMutation.mutate(id);
        });
    };

    const columns = [
        { field: "id", headerName: "ID" },
        { field: "name", headerName: "Nome" },
        { field: "price_kind", headerName: "Cotação" },
        { field: "position", headerName: "Ordem" },
        { field: "is_active", headerName: "Status" },
        { field: "actions", headerName: "Ações", type: "number" },
    ];

    const rows = dataList.map((row) => ({
        ...row,
        price_kind: kindLabel[row.price_kind] || row.price_kind,
        is_active: row.is_active ? "Ativo" : "Inativo",
    }));

    const renderActions = (row) => (
        <Stack spacing={1} direction="row" justifyContent="center">
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Ver detalhes" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/configuracao-metal-detalhes/${row.id}`}>
                        <FaMagnifyingGlass size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 2) && (
                <Tooltip title="Editar" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/configuracao-metal-editar/${row.id}`}>
                        <FaPen size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 4) && row.is_active === "Ativo" && (
                <Tooltip title="Desativar" arrow placement="top">
                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                        <FaTrash size={20} />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );

    return (
        <ListingPage
            canAddData={verifyPermission(componentName, 3)}
            isLoading={isFetching}
            icon={FaGear}
            pageTitle="Metais"
            addButtonTitle="metal"
            addPath="/configuracao-metal-cadastrar"
            columns={columns}
            data={rows}
            actions={renderActions}
        />
    );
}
